window.Hogan = require('hogan.js');
